import { api } from "./config"
import { useAuthStore } from "@/stores/authStore"
// const accessToken = useAuthStore.getState().auth.accessToken


export const login = async (data: any) => {
    const result = await api.post(`auth/login`, data).then((response: any) => response.data.data)
    return result
}


export const signUp = async (data: any) => {
    const result = await api.post(`auth/register`, data).then((response: any) => response.data.data)
    return result
}

export const forgotPassword = async (email: string) => {
    const result = await api.post(`auth/forgot-password`, { email }).then((response: any) => response.data.data)
    return result
}

export const renewPassword = async (token: string, password: string) => {
    const result = await api.post(`auth/reset-password`, { token, password }).then((response: any) => response.data.data)
    return result
}

interface ChangePasswordData {
    old_password: string
    new_password: string
    new_password_confirmation: string
}

export const changePassword = async (data: ChangePasswordData) => {
    const accessToken = useAuthStore.getState().auth.accessToken
    const response = await api.post(`auth/change-password`, data, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        },
    })
    return response.data.data
}

export const verifyAdminAccess = async (): Promise<boolean> => {
    try {
        const accessToken = useAuthStore.getState().auth.accessToken
        const response = await api.get('auth/verify-admin', {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        return response.data?.data?.is_admin === true
    } catch {
        return false
    }
}
